<template>
  <div class="cd_container py-5">
    <h2>Partners</h2>
    <div class="cd_partners">
      <div v-for="(partner, index) in partners" :key="index" class="cd_partner">
        <a :href="partner.href"><img :class="'align-self-center mr-3 cd_partner--image '+ partner.image.class" :src="partner.image.url" :alt="partner.title"/></a>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'Partners',
    data () {
      return {
        partners: [
          {
            title: "Appalachian Stewardship Foundation",
            href: "http://appalachianstewards.org/",
            image: {
              url: "https://assets.creekdog.org/asf-logo.svg",
              class: "asf"
            }
          },
          {
            title: "Trout Unlimited",
            href: "https://tu.org",
            image: {
              url: "https://assets.creekdog.org/trout-unlimited.svg",
              class: "tu"
            }
          },
          {
            title: "Dominion Energy",
            href: "https://sustainability.dominionenergy.com/community-development/philanthropy",
            image: {
              url: "https://assets.creekdog.org/dominion-energy-logo.svg",
              class: "dom"
            }
          },
          {
            title: "Friends of Deckers Creek",
            href: "https://creekdog.org",
            image: {
              url: "https://assets.creekdog.org/fodc-logo.svg",
              class: "fodc"
            }
          }
        ]
      }
    }
  }
</script>
